export class Heater {
    heaterId: number;
    waterInletTemperature: number;
    waterOutletTemperature: number;

    constructor(heaterId: number, waterInletTemperature: number, waterOutletTemperature: number) {
        this.heaterId = heaterId;
        this.waterInletTemperature = waterInletTemperature;
        this.waterOutletTemperature = waterOutletTemperature;
    }
}
